import { useEffect, useState } from 'react';
import {
  OcorrenciaResponse,
  listHiringHistoryOcorrencias,
} from 'services/actions/ai_management_hiring_history';
import { listPossibleCompetitorOcorrencias } from 'services/actions/ai_management_possible_competitors';

interface State {
  ocorrencias: OcorrenciaResponse[];
  pending: boolean;
  loading: boolean;
  error: boolean;
}

const initialState: State = { ocorrencias: [], pending: false, loading: true, error: false };

export function useHiringHistoryOcorrencias(
  biddingId: number | null,
  historicBiddingId: number | null,
  cnpj?: string,
) {
  const [state, setState] = useState<State>(initialState);

  useEffect(() => {
    if (!biddingId || !historicBiddingId) {
      setState({ ...initialState, loading: false });
      return undefined;
    }

    let active = true;
    setState({ ...initialState, loading: true });

    const request = cnpj
      ? listPossibleCompetitorOcorrencias(biddingId, historicBiddingId, cnpj)
      : listHiringHistoryOcorrencias(biddingId, historicBiddingId);

    request
      .then(({ data }) => {
        if (!active) return;
        setState({
          ocorrencias: data.ocorrencias ?? [],
          pending: Boolean(data.pendente),
          loading: false,
          error: false,
        });
      })
      .catch(() => {
        if (active) setState({ ...initialState, loading: false, error: true });
      });

    return () => {
      active = false;
    };
  }, [biddingId, historicBiddingId, cnpj]);

  return state;
}
